import AddIcon from '@mui/icons-material/Add';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { useSearchParams } from "react-router-dom";
import AsyncButton from "../../components/AsyncButton/AsyncButton";
import Attachments from "../../components/Attachments/Attachments";
import TabsLayout from "../../components/Tabs/TabsLayout";
import { formatAzureFiles } from "../../lib/helperFuncs";
import HttpService from "../../services/HttpService";
import { phaseMapper, queueJsons, queueMapper } from "./static/applicationMappers";

const ApplicationForms = () => {
  document.title = "Επεξεργασία ΠΣΚΕ Φορμών";
  // Different Forms States
  const [mainform, setMainForm] = React.useState<Array<{ title: string; form?: any }>>([]);
  const [extraform, setExtraForm] = React.useState<Array<{ title: string; form?: any }>>([]);
  const [evaluationform, setEvaluationForm] = 
    React.useState<Array<{ title: string; form?: any }>>([]);
  const [evaluationBoardform, setEvaluationBoardForm] = 
    React.useState<Array<{ title: string; form?: any }>>([]);
  const [requestModificationform, setRequestModificationForm] = 
    React.useState<Array<{ title: string; form?: any }>>([]);
  const [requestModificationEvaluationform, setRequestModificationEvaluationForm] = 
    React.useState<Array<{ title: string; form?: any }>>([]);
  const [requestAidform, setRequestAidForm] =
    React.useState<Array<{ title: string; form?: any }>>([]);
  const [verificationReportform, setVerificationReportForm] =
    React.useState<Array<{ title: string; form?: any }>>([]);
  const [certificationReportform, setCertificationReportForm] =
    React.useState<Array<{ title: string; form?: any }>>([]);
  const [aidPaymentform, setAidPaymentForm] =
    React.useState<Array<{ title: string; form?: any }>>([]);
  const [excelValuesform, setExcelValuesForm] =
    React.useState<Array<{ title: string; form?: any }>>([]);
  const [chatGPTform, setChatGPTForm] =
    React.useState<Array<{ title: string; form?: any }>>([]);

  const stateHandler = (phase: string, form: any, action: 'get' | 'set'): any => {
    switch (phase) {

    case 'main':

      return action === 'set'
        ? setMainForm(form)
        : mainform;

    case 'extra':
      return action === 'set'
        ? setExtraForm(form)
        : extraform;

    case 'evaluation':
      return action === 'set'
        ? setEvaluationForm(form)
        : evaluationform;

    case 'evaluationBoard': 
      return action === 'set'
        ? setEvaluationBoardForm(form)
        : evaluationBoardform;

    case 'requestModification': 
      return action === 'set'
        ? setRequestModificationForm(form)
        : requestModificationform;

    case 'requestModificationEvaluation': 
      return action === 'set'
        ? setRequestModificationEvaluationForm(form)
        : requestModificationEvaluationform;

    case 'requestAid': 
      return action === 'set'
        ? setRequestAidForm(form)
        : requestAidform;

    case 'verificationReport': 
      return action === 'set'
        ? setVerificationReportForm(form)
        : verificationReportform;

    case 'certificationReport': 
      return action === 'set'
        ? setCertificationReportForm(form)
        : certificationReportform;

    case 'aidPayment': 
      return action === 'set'
        ? setAidPaymentForm(form)
        : aidPaymentform;

    case 'excelValues': 
      return action === 'set'
        ? setExcelValuesForm(form)
        : excelValuesform;

    case 'chatGPTValues': 
      return action === 'set'
        ? setChatGPTForm(form)
        : chatGPTform;

    default:
      break;
    }
  };
  
  const [searchParams, setSearchParams] = useSearchParams();

  const [valueSearched, setValueSearched] = React.useState<string>('');
  const [selectOption, setSelectOption] = React.useState<string>('');

  const [tab, setTab] = React.useState(0);
  const [tabLabels, setTabLabels] = React.useState([]);

  const [applSearched, setApplSearched] = React.useState<{
    id: number | undefined, 
    fundType: string
  }>();
  const [files, setFiles] = React.useState<string[]>([]);

  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
  
  const [error, setError] = React.useState<string>();
  const formRef = React.useRef<any>(null);

  const createFormObject = (json_form: any) => {
    if (!json_form || json_form === 'null') return [];
    const formArray = Object.keys(json_form).map((x) => {
      return {
        title: x,
        ...(Object.keys(json_form[x]).length && {
          form: json_form[x],
        }),
      };
    });
    return formArray;
  };

  const addChatGPTSection = (phase: string, selectOption: string) => {
    const formState = stateHandler(phase, {} , 'get');
    const new_form: any = {};
    formState.map((form: {title: string, form: any}) => Object.assign(
      new_form, 
      { [form.title]: form.form }
    ));

    new_form[selectOption] = queueJsons[selectOption];
    const form = createFormObject(new_form);
    stateHandler(phase, form, 'set');
  };

  const addPDFValues = (phase: string): void => {
    const form = createFormObject(queueJsons[phase]);
    stateHandler(phase, form, 'set');
  };

  const addCoProducer = () => {
    const formState = stateHandler('chatGPTValues', {} , 'get');
    const new_form: any = {};
    formState.map((form: {title: string, form: any}) => Object.assign(
      new_form, 
      { [form.title]: form.form }
    ));
    new_form['sectionEQueue'] = [
      ...new_form['sectionEQueue'],
      { "co-producer": '' }
    ];
    const form = createFormObject(new_form);
    stateHandler('chatGPTValues', form, 'set');
  };

  const buildFormLeaf = ({ formField, name, value }: any) => {
    return (
      <TextField
        fullWidth
        defaultValue={value}
        label={formField}
        name={`${name}___${formField}`}
      />
    );
  };

  const handleSubmit = async (event: any, phase: string) => {
    event.preventDefault();
    const formData = new FormData(formRef.current);
    const values: any = {};
    formData.forEach((value, key) => {
      values[key] = value;
    });
    setIsSubmitting(true);
    try {
      const form_object: any = {};
      Object.keys(values).map(value => {
        const title = value.split('___')[0];
        const nest = value.split('___')[1];
        if (!(title in form_object)) {
          Object.assign(form_object, { [title]: Number.isInteger(Number(nest))
            ? []
            : {}
          });
        }
        if (Number.isInteger(Number(nest))) {
          form_object[title][Number(nest)] = Object.assign(form_object[title][Number(nest)] || {}, {[value.split('___')[2]]: values[value]}) ;
        } else form_object[title][nest] = values[value];
      });
      await HttpService.getAxiosClient().put(`${process.env.REACT_APP_BACKEND_URL}/applications-pske/${applSearched?.id}/${phase}`, form_object);
      enqueueSnackbar('Επιτυχής Αποθήκευση των τιμών!', { variant: 'success' });
    } catch (error) {
      console.error(error); 
      enqueueSnackbar('Κάτι πήγε λάθος με την Αποθήκευση! Προσπαθήστε ξανά αργότερα!', { variant: 'error' });
    } finally {
      setIsSubmitting(false);
    }

  };

  const buildDropdownOptions = (
    inner_form: Array<{ title: string; form?: any }>, 
    requestAidform: any[]
  ): any[] => {
    return Object
      .keys(queueMapper)
      .filter(queue => requestAidform.length === 0
        ? (queue === 'pdfQueue' || queue === 'sectionEQueue')
        : queue
      )
      .filter(queue => !inner_form.some(form => form.title === queue));
  };

  const buildForm = (inner_form: Array<{ title: string; form?: any }>, phase: string) => {    
    return (
      <>
        {
          phase === 'chatGPTValues' && (
            <Box display='flex'
              gap={2}
              mt={2}
              mb={4}>
              <FormControl fullWidth>
                <InputLabel id='add-section'>Προσθήκη Ενότητας</InputLabel>
                <Select
                  labelId='add-section'
                  id='select-add-section'
                  label='Προσθήκη Ενότητας'
                  onChange={(e) => setSelectOption(e.target.value as string)}
                >
                  {buildDropdownOptions(inner_form, requestAidform)
                    .map(x => {
                      return <MenuItem key={x} value={x}>{queueMapper[x]}</MenuItem>;
                    })
                  }
                </Select>
              </FormControl>
              <Button 
                variant='contained'
                onClick={() => addChatGPTSection(phase, selectOption)}
              >
                Προσθήκη
              </Button>
            </Box>
          )
        }
        {
          (phase === 'excelValues' && requestAidform?.length > 0 && excelValuesform?.length === 0) && (
            <Box display='flex'
              justifyContent='end'
              gap={2}
              mt={2}
              mb={4}>
              <Button 
                variant='contained'
                onClick={() => addPDFValues(phase)}
              >
                Προσθήκη Τιμών
              </Button>
            </Box>
          )
        }
        {
          inner_form.length === 0
            ? <Box 
              display='flex'
              justifyContent='center'
              mt={5}>
              <Typography variant='h4'>
                {
                  ((phase === 'excelValues' || phase === 'requestAid') && requestAidform.length === 0)
                    ? 'Η Αίτηση δεν έχει φτάσει ακόμα στο στάδιο: Αίτημα Καταβολής Ενίσχυσης (Ελέγχου)'
                    : 'Δεν υπάρχει Φόρμα στην συγκεκριμένη φάση'
                }
              </Typography>
            </Box> 
            : <form ref={formRef} onSubmit={(e: any) => handleSubmit(e, phase)}>
              <Box 
                display='flex' 
                flexDirection='column'
                gap={2}
                my={2}
              >
                {inner_form.map((x) => {
                  return (
                    <>
                      {
                        x.form 
                          ? <>
                            <Typography variant='h3'>
                              {phase === 'chatGPTValues'
                                ? <>
                                  {queueMapper[x?.title]}
                                  {x?.title === 'sectionEQueue' && <Button
                                    onClick={addCoProducer}
                                    sx={{ float: 'right' }}
                                    variant='contained'
                                    startIcon={<AddIcon />}
                                  >
                                    Προσθήκη Συμπαραγωγού
                                  </Button>
                                  }
                                </>
                                : x?.title
                              }
                            </Typography>
                            {
                              Array.isArray(x.form) 
                                ? (
                                  x.form.map((ff, index) => {
                                    return (
                                      <>
                                        <Typography>#{index + 1}</Typography>
                                        {Object.keys(ff).map((yy) => {
                                          return buildFormLeaf({
                                            formField: yy, //label
                                            name: `${x.title}___${index}`, //name
                                            value: ff[yy], //value
                                          });
                                        })}
                                      </>
                                    );
                                  })
                                ) 
                                : (
                                  Object.keys(x.form).map((ff) => {
                                    return buildFormLeaf({
                                      formField: ff, //label
                                      name: x.title, //name
                                      value: x.form[ff], //value
                                    });
                                  })
                                )
                            }
                          </>
                          : <></>
                      }
                    </>
                  );
                })}
              </Box>
              <AsyncButton
                type='submit'
                title='Αποθήκευση'
                isLoading={isSubmitting}
              />
            </form>
        }
      </>
      
    );
  };

  const searchForm = async (value: string) => {
    if (!value) return enqueueSnackbar('Εισάγετε Κωδικό για την Αναζήτηση',
      {
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right'
        }
      }
    );

    try {
      setError('');
      setIsLoading(true);
      const [{ data: applicationJson }, { data: applicationFiles }] = await Promise.all([
        await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/applications-pske/${value}`),
        await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/applications-pske/files/${value}`)
      ]);
      setFiles(applicationFiles.map((file: {url: string, file: File}) => file.url));
      setApplSearched({
        id: applicationJson[0].id,
        fundType: applicationJson[0].fund_type
      });
      const labels = applicationJson.map(
        (appl:
          {phase: string, application_code: string, pdf_value: any}
        ) => {
          return appl.phase && {
            label: <Typography variant='h4'>{phaseMapper[appl.phase]}</Typography>,
            phase: appl.phase
          };
        }
      ).filter(Boolean);
      
      setTabLabels(labels);
      for (const applJson of applicationJson) {
        const form = createFormObject(applJson.pdf_value);
        stateHandler(applJson.phase, form, 'set');
      }

    } catch (error: any) {
      console.error(error);
      if (error?.response?.status === 404) setError(error.response.data.message);
      else setError('Κάτι πήγε λάθος! Προσπαθήστε ξανά!');
    } finally {
      setIsLoading(false);
    }
  };

  const tabContent = [...Array.from(tabLabels).map((x: any) => {
    const tabState = stateHandler(x.phase, {}, 'get');
    return buildForm(tabState, x.phase);
  })];

  // TODO: DO NOT DELETE YET
  // const addField = (field: {label: string, content: string}) => {
  //   const formState = stateHandler(phaseAppend?.phase || '', {} , 'get');
  //   const new_form = {};
  //   formState.map((form: {title: string, form: any}) => Object.assign(
  //     new_form, 
  //     {
  //       [form.title]: {
  //         ...form.form,
  //         ...(form.title === phaseAppend?.title && {
  //           [field.label]: field.content
  //         })
  //       }
  //     }
  //   ));
  //   const form = createFormObject(new_form);
  //   stateHandler(phaseAppend?.phase || '', form, 'set');
  //   setOpen(false);
  // };


  // useEffect for fetching based on searchParams
  React.useEffect(() => {
    for (const entry of searchParams.entries()) {
      const [param, value] = entry;
      if (param === 'appl_code') {
        setValueSearched(value);
        searchForm(value);
      } 
    }
  }, [searchParams]);


  const changeFundType = async (fund_type: string) => {
    try {
      await HttpService.getAxiosClient().patch(`${process.env.REACT_APP_BACKEND_URL}/applications-pske/${applSearched?.id}`, {
        fundtype: fund_type
      });
      enqueueSnackbar('Επιτυχής Αλλαγή Είδους Χρηματοδότησης!', { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Κάτι πήγε λάθος με την Αλλαγή Είδους Χρηματοδότησης! Προσπαθήστε Ξανα Αργότερα', { variant: 'error' });
    }
  };

  return (
    <>
      <Box
        display='flex'
        my={5}
        gap={2}>
        <TextField
          value={valueSearched}
          onChange={(e) => setValueSearched(e.target.value)}
          fullWidth
          label='Αναζήτηση με Κωδικό Αίτησης'
        />
        <Button 
          color='primary' 
          variant='contained'
          onClick={() => setSearchParams({appl_code: valueSearched})}>
          Αναζήτηση
        </Button>
      </Box>
      {
        isLoading
          ? <Box display='flex' justifyContent='center'>
            <CircularProgress /> 
          </Box>
          : error
            ? <Typography display='flex' justifyContent='center'
              variant='body1' fontWeight='bold'>
              {error}
            </Typography>
            : applSearched?.id && <>
              <Box 
                display='flex'
                alignItems='center'
                gap={2}
                m={1}>
                <Typography variant='h4'>
                  Είδος Χρηματοδότησης: 
                </Typography>
                <TextField
                  variant='standard'
                  value={applSearched.fundType}
                  onChange={
                    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                      setApplSearched((prevApplSearched) => {
                        return {
                          id: prevApplSearched?.id,
                          fundType: event.target.value
                        };
                      });
                    }
                  }
                />
                <Button variant='outlined' onClick={() => changeFundType(applSearched.fundType)}>Αλλαγή Χρηματοδότησης</Button>
              </Box>
              <Grid container gap={5}>
                <Grid item 
                  xs={12}
                  md={8}>
                  <TabsLayout
                    tab={tab}
                    setTab={setTab}
                    tabLabels={tabLabels}
                    tabContent={tabContent}
                    scrollable
                  />
                </Grid>
                <Grid 
                  item
                  xs={12}
                  md>
                  <Typography variant='h3' sx={{ mb: 2}}>
                    Αρχεία Υπόθεσης
                  </Typography>
                  <Box mb={{xs: 2, lg: 0}}>
                    {files?.length
                      ? <Attachments attachments={formatAzureFiles(files)} direction='column' />
                      : 'Η Συγκεκριμένη Αίτηση δεν έχει Αρχεία'
                    }
                  </Box>
                </Grid>
              </Grid>
            </> 
      }
    </>
  );
};

export default ApplicationForms;
